import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { IconComponent } from '../icon/icon.component';
import { InfoDialogComponent, InfoDialogData } from '../info-dialog/info-dialog.component';
import { LinkContainerComponent } from '../link-container/link-container.component';

@Component({
  selector: 'shared-button-with-image',
  imports: [LinkContainerComponent, IconComponent],
  templateUrl: './button-with-image.component.html',
  styleUrls: ['./button-with-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonWithImageComponent {
  @Input() headline: string | undefined;
  @Input() description: string | undefined;
  @Input() imagePath: string | undefined;
  @Input() showArrowIcon = false;
  @Input() isSelected = false;
  @Input() contentStyleClass: string | undefined;
  @Input() routerLink: string | string[] | undefined;
  @Input() help: InfoDialogData | undefined;

  private readonly dialogService = inject(DialogService);

  protected showInfoModal(): void {
    if (this.help == null) return;

    const data: InfoDialogData = {
      header: this.help.header,
      customTemplate: this.help.customTemplate,
    };

    this.dialogService.open(InfoDialogComponent, {
      data,
      closable: false,
      closeOnEscape: true,
      transitionOptions: '0ms',
      modal: true,
    });
  }
}
